import { ref, computed } from "vue";

export function useScreenHelper() {
  const screenWidth = ref(screen.width);
  const isMobile =
    computed(() => screenWidth.value <= 768) ||
    /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isTablet = computed(
    () => screenWidth.value > 768 && screenWidth.value <= 1024,
  );
  return { screenWidth, isMobile, isTablet };
}
